import React from 'react'

export const About = () => {
  return (
    <section id="about" className='about' >
      <div className='about__container'>
      <h2 className='about__h2'>ABOUT ME</h2>
      <p className='about__p'>就學期間恰巧碰到UI領域，並開始學習UI相關技術，透過線上學習平台及相關書籍自學，以Figma為主要設計工具，自學的過程也累積了一些作品，產生了興趣，因此將UI/UX設計師定為職業目標。</p>
      </div>
    </section>
  )
}
